import { createTheme } from 'components/base';
import { custom2, custom3 } from 'assets/colors';

export const createTimePickerTheme = createTheme({
  palette: {
    primary: {
      main: custom2.main,
    },
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: '.875rem',
        },
        input: {
          padding: '6px 16px',
          height: '42px',
          margin: '0 !important',
          border: 'none !important',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          position: 'static',
          transform: 'none',
          padding: '5px',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: custom3.scrollTrackColor,
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: ' custom2.main',
            borderRadius: 10,
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: ' custom2.main',
          },
        },
      },
    },
    MuiPopper: {
      styleOverrides: {
        root: {
          zIndex: '99999 !important',
        },
      },
    },
  },
});
